import React from 'react'
import styled from 'styled-components'
import Arrow from '../../../assets/Icons/Arrow.png'
import { device } from '../Utlis/media'

const Button = styled.button<ButtonStyleProps & { $textAlign?: 'left' | 'center'; $needArrow?: boolean }>`
  width: ${(props) =>
    props.isPercent ? `${props.width}%` : `${props.width}px`};
  border: none;
  border-radius: 16px;
  font-family: Urbanist, sans-serif;
  font-size: 17px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: 0.02em;
  text-align: ${(props) => props.$textAlign || 'center'};
  padding-left: ${(props) => (props.$textAlign === 'left' ? '24px' : '0px')};
  padding-right: ${(props) => (props.$needArrow ? '52px' : '0px')};
  cursor: pointer;
  position: relative;
  height: ${(props) => (props.height ? props.height : 54)}px;
  color: #ffffff;
  transition:
    transform 0.2s ease,
    box-shadow 0.25s ease,
    filter 0.25s ease,
    opacity 0.2s ease,
    background 0.25s ease;

  ${(props) =>
    props.flag === true
      ? `
    background: #ebe7e2;
    color: #9a948c;
    font-weight: 700;
    cursor: not-allowed;
    box-shadow: none;
    `
      : `
    background: linear-gradient(144.01deg, rgba(255, 201, 81, 0.85) 0%, rgba(206, 86, 176, 0.85) 100%);
    box-shadow: 0 10px 28px rgba(206, 86, 176, 0.32);

    &:hover {
      transform: translateY(-1px);
      filter: brightness(1.04);
      box-shadow: 0 14px 32px rgba(206, 86, 176, 0.4);
    }

    &:active {
      transform: translateY(0);
      filter: brightness(0.98);
    }
    `}

  @media ${device.tablet} {
    font-size: 15px;
  }
`

const ArrowImage = styled.img`
  width: 14px;
  height: 12px;
  filter: invert(36%) sepia(87%) saturate(1637%) hue-rotate(293deg)
    brightness(88%) contrast(92%);
  transition: transform 0.25s ease;
`

const ArrowContainer = styled.div`
  width: 32px;
  height: 32px;
  background-color: #ffffff;
  border-radius: 10px;
  align-items: center;
  display: flex;
  justify-content: center;
  position: absolute;
  right: 11px;
  top: 50%;
  transform: translateY(-50%);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  ${Button}:not(:disabled):hover & {
    transform: translateY(-50%) scale(1.05);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

    ${ArrowImage} {
      transform: translateX(2px);
    }
  }
`

interface ButtonProps {
  text: string
  width: number
  needArrow: boolean
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  active?: boolean
  height?: number
  isPercent?: boolean
  textAlign?: 'left' | 'center'
}

interface ButtonStyleProps {
  width: number
  flag?: boolean
  height?: number
  isPercent?: boolean
}

const SubmitButton: React.FC<ButtonProps> = ({
  text,
  width,
  needArrow,
  onClick,
  active,
  height,
  isPercent = false,
  textAlign = 'center',
}) => {
  return (
    <Button
      width={width}
      height={height}
      isPercent={isPercent}
      flag={active}
      disabled={active}
      onClick={onClick}
      $textAlign={textAlign}
      $needArrow={needArrow}
    >
      {text}
      {needArrow ? (
        <ArrowContainer>
          <ArrowImage src={Arrow} alt="" />
        </ArrowContainer>
      ) : null}
    </Button>
  )
}

export default SubmitButton
